import _Routes from "@components/_Routes";
import Footer from "@components/_Layout/Footer";
import Navbar from "@components/_Layout/Navbar";
import { _AppProvider } from "@providers";
import { BrowserRouter as Router } from "react-router-dom";
import { Toaster } from "react-hot-toast";

function App() {
  return (
    <>
      <Toaster
        containerStyle={{ zIndex: 99999999 }}
        position={"top-center"}
        toastOptions={{
          success: {
            iconTheme: {
              primary: "#009844",
              secondary: "#fff",
            },
          },
          error: {
            iconTheme: {
              primary: "#eb4a61",
              secondary: "#fff",
            },
          },
        }}
      />
      <Router>
        <_AppProvider>
          <Navbar />
          <div className="tw-flex tw-flex-col tw-justify-between min-h-screen-nav">
            <main className="tw-py-8">
              <_Routes />
            </main>
            <Footer
              clientInfo={{
                name: process.env.REACT_APP_CUSTOMER_NAME!!,
                url: process.env.REACT_APP_CUSTOMER_URL!!,
              }}
              links={[
                {
                  name: "Mentions légales",
                  target: "_blank",
                  url: "#",
                },
                {
                  name: "Conditions générales d'utilisation",
                  target: "_blank",
                  url: "#",
                },
                {
                  name: "RGPD",
                  target: "_blank",
                  url: "#",
                },
              ]}
            />
          </div>
        </_AppProvider>
      </Router>
    </>
  );
}

export default App;
